import apiClient from 'core/api/client';
import type {
  AcceptInvitationBody,
  AcceptInvitationResponse,
  CreateInvitationBody,
  CreateInvitationResponse,
  InvitationListItem,
  ValidateInvitationResponse,
} from 'types/api.generated';

export const validateInvitation = async (token: string): Promise<ValidateInvitationResponse> => {
  const { data } = await apiClient.get<ValidateInvitationResponse>(
    '/api/v1/public/invitations/validate',
    { params: { token } },
  );
  return data;
};

export const acceptInvitation = async (
  body: AcceptInvitationBody,
): Promise<AcceptInvitationResponse> => {
  const { data } = await apiClient.post<AcceptInvitationResponse>(
    '/api/v1/user/invitations/accept',
    body,
  );
  return data;
};

export const listOrgInvitations = async (): Promise<InvitationListItem[]> => {
  const { data } = await apiClient.get<InvitationListItem[]>('/api/v1/organizations/invitations');
  return data;
};

export const createOrgInvitation = async (
  body: CreateInvitationBody,
): Promise<CreateInvitationResponse> => {
  const { data } = await apiClient.post<CreateInvitationResponse>(
    '/api/v1/organizations/invitations',
    body,
  );
  return data;
};

export const revokeOrgInvitation = async (invitationId: string): Promise<void> => {
  await apiClient.delete(`/api/v1/organizations/invitations/${invitationId}`);
};

export const resendOrgInvitation = async (invitationId: string): Promise<void> => {
  await apiClient.post(`/api/v1/organizations/invitations/${invitationId}/resend`);
};
